import React from "react";
import { Row, Col, DatePicker, Select, Button, Space } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({
  startDate,
  endDate,
  groupBy,
  onDateChange,
  onGroupByChange,
  onSearch,
  onClear,
  loading,
}) => {
  return (
    <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 24 }}>
      <Col>
        <RangePicker
          value={[
            startDate ? dayjs(startDate) : null,
            endDate ? dayjs(endDate) : null,
          ]}
          onChange={(dates) => {
            if (dates) {
              onDateChange(
                dates[0].format("YYYY-MM-DD"),
                dates[1].format("YYYY-MM-DD")
              );
            }
          }}
          format="DD/MM/YYYY"
        />
      </Col>
      {onGroupByChange && (
        <Col>
          <Select
            value={groupBy || "month"}
            onChange={onGroupByChange}
            style={{ width: 120 }}
            options={[
              { value: "day", label: "Por dia" },
              { value: "week", label: "Por semana" },
              { value: "month", label: "Por mes" },
            ]}
          />
        </Col>
      )}
      <Col>
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={onSearch}
            loading={loading}
          >
            Buscar
          </Button>
          <Button icon={<ReloadOutlined />} onClick={onClear}>
            Limpar
          </Button>
        </Space>
      </Col>
    </Row>
  );
};

export default DateRangeFilter;
